const MIN_RECONNECT_MS = 1_000;
const MAX_RECONNECT_MS = 30_000;

export function nextReconnectDelay(attempt: number): number {
  return Math.min(MAX_RECONNECT_MS, MIN_RECONNECT_MS * 2 ** Math.max(0, attempt));
}
